<template>
  <div>
    <naj-button
      v-if="type == actionType.serverAction"
      v-bind="attrs"
      @click="$emit('click-action')"
    >
      <slot />
    </naj-button>

    <naj-button
      v-if="type == actionType.popup || type == actionType.addNew || type == actionType.edit || type == actionType.clone"
      v-bind="attrs"
      @click="$emit('open-popup')"
    >
      <slot />
    </naj-button>

    <naj-button
      v-if="type == actionType.delete"
      v-bind="attrs"
      color="error"
      @click="$emit('open-delete-popup')"
    >
      <slot />
    </naj-button>

    <naj-button
      v-if="type == actionType.redirect"
      v-bind="attrs"
      :to="url"
    >
      <slot />
    </naj-button>

    <naj-button
      v-if="type == actionType.redirectToNewTab || type == actionType.gridPrinting"
      v-bind="attrs"
      :to="url"
      target="_blank"
    >
      <slot />
    </naj-button>

    <naj-button
      v-if="type == actionType.exportExcel"
      v-bind="attrs"
      @click="$emit('export-to-excel')"
    >
      <slot />
    </naj-button>

    <v-menu
      v-if="type == actionType.menu && hasSubActions"
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-icon v-on="on">
          mdi-dots-vertical
        </v-icon>
      </template>
      <v-list>
        <template v-for="(actionItem,i) in subActions">
          <v-list-item
            v-if="actionItem && item[actionItem.actionValue]"
            :key="i"
          >
            <v-list-item-title class="menu-item">
              <naj-action-button
                size="small"
                class="menu-item-action"
                :type="actionItem.slot"
                :action="actionItem"
                :url="item[actionItem.actionValue]"
                @click-action="submitAction('onActionClick',item,actionItem)"
                @open-popup="submitAction('openModal',item,actionItem)"
                @open-delete-popup="submitAction('deleteConfirmationModal',item,actionItem)"
              >
                {{ actionItem.header }}
              </naj-action-button>
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { actionType } from '@/helpers/enum';
import { executeString } from '@/helpers/utils';

export default {
  name: 'NajActionButton',
  inheritAttrs: true,
  props: {
    type: { required: true },
    url: { required: false },
    action: {
      type: Object,
      required: false,
      default: null,
    },
    item: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      executeString,
      actionType,
    };
  },
  computed: {
    attrs() {
      const { ...attrs } = this.$attrs;
      return attrs;
    },
    subActions() {
      return (this.action?.actions || []).map((column) => {
        if (!column.actionValue) { column.actionValue = column.actionType ? column.name : null; }
        if (!column.header) { column.header = column.text || column.actionName; }
        if (!column.slot) { column.slot = column.actionType; }
        return column;
      });
    },
    hasSubActions() {
      return (this.subActions).length > 0;
    },
  },
  methods: {
    submitAction(actionName, item, actionItem) {
      this.$emit('inner-menu-action', actionName, item, actionItem);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .menu-item {
  .menu-item-action {
    .v-button-wrapper {
      min-width: 100%;
      .naj-button {
        width: 100%;
      }
    }
  }
}
</style>

